export const NEWS = "NEWS"